import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import { routerMiddleware } from "connected-react-router";
import { composeWithDevTools } from "redux-devtools-extension";
import ReduxThunk from "redux-thunk";
import storage from "redux-persist/lib/storage";

import app from "./reducers/auth";
import auth from "./reducers/auth";
import utils from "./reducers/utils";
import removals from "./reducers/removals";
import notifies from "./reducers/notifies";
import users from "./reducers/users";
import sensors from "./reducers/sensors"
import reports from "./reducers/reports";
import transporters from "./reducers/transporters";
import dispositions from "./reducers/dispositions";
import learning from "./reducers/learning";

import { createBrowserHistory } from "history";

const createRootReducer = (history) =>
  combineReducers({
    app,
    auth,
    utils,
    sensors,
    removals,
    notifies,
    users,
    reports,
    transporters,
    dispositions,
    learning,
  });

// * -------- Estado inicial de la aplicación
const initialState = {};

// * -------- Middlewares
export const history = createBrowserHistory();
const middlewares = [ReduxThunk, routerMiddleware(history)];

// * -------- Enhancers del store --------
const enhancers = [];

// * -------- Componer Middlewares y Enhancers --------
let composedEnhancers = null;
if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test") {
  const composeEnhancers = composeWithDevTools({ trace: true });
  composedEnhancers = composeEnhancers(
    applyMiddleware(...middlewares),
    ...enhancers
  );
} else {
  composedEnhancers = compose(applyMiddleware(...middlewares), ...enhancers);
}

// * -------- Configuración del Persist --------
const persistConfig = {
  key: "root",
  storage,
  blacklist: ["router"],
  whitelist: ["auth"],
};

const persistedReducer = persistReducer(
  persistConfig,
  createRootReducer(history)
);

export default function configureStore() {
  const store = createStore(persistedReducer, initialState, composedEnhancers);
  const persistor = persistStore(store);
  return { store, persistor };
}
